import Raven from 'raven-js';
import { initTracker } from 'documents-lib/js/tracking/tracker';
import * as PublicActivityApi from '../api/PublicActivityApi';
import * as ViewerCache from '../utils/ViewerCache';
const viewPage = ({
  presentation,
  activityId,
  pageIndex
}) => {
  if (!presentation) return Promise.reject(new Error('No presentation'));
  return PublicActivityApi.viewPage(presentation.id, presentation.accessId, activityId, pageIndex);
};
export const configurePublicActivityMiddleware = (stateToPresentation, handlers) => ({
  getState
}) => {
  let activityId = null;
  return next => action => {
    switch (action.type) {
      case handlers.identify:
        {
          const {
            presentation
          } = stateToPresentation(getState());
          initTracker({
            isPublic: true
          });
          if (presentation === null || presentation === undefined) return;
          PublicActivityApi.createActivity(presentation.id, presentation.accessId, action.payload // this is the viewer record
          ).then(activity => {
            activityId = activity;
            viewPage({
              presentation,
              activityId,
              pageIndex: 0
            }).catch(err => console.error(err));
          }).catch(err => console.error(err));
          break;
        }
      case handlers.viewPage:
        {
          if (activityId === null) {
            break;
          }
          const {
            presentation
          } = stateToPresentation(getState());
          viewPage({
            presentation,
            activityId,
            pageIndex: action.payload
          }).catch(err => console.error(err));
          break;
        }
      case handlers.finish:
        {
          if (activityId === null) {
            break;
          }
          const {
            presentation
          } = stateToPresentation(getState());
          if (presentation === null || presentation === undefined) return;
          PublicActivityApi.finishActivity(presentation.id, presentation.accessId, activityId).catch(err => console.error(err));
          break;
        }
      case handlers.identifyCHIRP:
        {
          const {
            sharedLink
          } = stateToPresentation(getState());
          initTracker({
            isPublic: true
          });
          if (sharedLink === null || sharedLink === undefined) return;
          PublicActivityApi.createActivityCHIRP({
            documentId: sharedLink.id,
            accessId: sharedLink.accessId,
            viewer: action.payload
          }).then(viewSessionResponse => {
            activityId = viewSessionResponse.activityId;
            PublicActivityApi.startPageCHIRP({
              accessId: sharedLink.accessId,
              documentId: sharedLink.id,
              activityId,
              pageNumber: 1,
              userId: sharedLink.userId
            }).catch(err => Raven.captureException(err, {
              extra: {
                context: 'CHIRP startPage after createViewSession'
              }
            }));
          }).catch(err => {
            Raven.captureException(err, {
              extra: {
                context: 'CHIRP createViewSession'
              }
            });
          });
          break;
        }
      case handlers.changePageCHIRP:
        {
          if (activityId === null) {
            break;
          }
          const {
            sharedLink
          } = stateToPresentation(getState());
          if (!sharedLink) return;
          const viewer = ViewerCache.get();
          PublicActivityApi.startPageCHIRP({
            accessId: sharedLink.accessId,
            documentId: sharedLink.id,
            activityId,
            pageNumber: action.payload.enteringPageNumber,
            userId: sharedLink.userId
          }).then(() => {
            if (activityId === null) {
              return;
            }
            PublicActivityApi.finishPageCHIRP({
              accessId: sharedLink.accessId,
              activityId,
              documentId: sharedLink.id,
              pageNumber: action.payload.leavingPageNumber,
              viewer
            }).catch(err => Raven.captureException(err, {
              extra: {
                context: 'CHIRP finishPage on page change'
              }
            }));
          }).catch(err => Raven.captureException(err, {
            extra: {
              context: 'CHIRP startPage on page change'
            }
          }));
          break;
        }
      case handlers.finishSessionCHIRP:
        {
          if (activityId === null) {
            break;
          }
          const {
            sharedLink
          } = stateToPresentation(getState());
          if (!sharedLink) return;
          const viewer = ViewerCache.get();
          PublicActivityApi.finishPageCHIRP({
            accessId: sharedLink.accessId,
            activityId,
            documentId: sharedLink.id,
            pageNumber: action.payload.pageNumber,
            viewer,
            // When the session is finished, indicate that while leaving the page, the
            // document is also closing (as opposed to just changing pages).
            documentClosing: true
          }).catch(err => {
            Raven.captureException(err, {
              extra: {
                context: 'CHIRP finishPage on session end'
              }
            });
          });
          break;
        }
      default:
        break;
    }
    return next(action);
  };
};